export enum OperationTypeEnums {
  ADD,
  UPDATE,
  DELETE,
}
